import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoginMutation } from 'bxcommon/store/endpoints/user.endpoints';
import BaseLogin from 'bxcommon/components/BaseLogin/BaseLogin';
import errorService, { LOGIN_ERRORS } from 'bxcommon/helpers/errors.helper';

export const UserLogin = () => {
  const { t: common } = useTranslation('common');

  const [login] = useLoginMutation();

  const warning = useCallback((error) => {
    errorService.handleErrorToast(error, LOGIN_ERRORS);
  }, []);

  const handleLogin = async (credentials) => {
    try {
      await login({ data: credentials, loginAsAdmin: false }).unwrap();
    } catch (error) {
      errorService.handleErrorToast(error, LOGIN_ERRORS);
    }
  };

  return <BaseLogin login={handleLogin} warning={warning} heading={common('login.heading')} />;
};

export default UserLogin;
